const activityRoutes = [
  {
    path: '/activity/sign521',
    name: 'activity-sign521',
    component: () => import('@/views/activity/activity-sign521')
  },
  {
    path: '/activity/qr-sign/:activityId',
    name: 'activity-qr-sign',
    component: () => import('@/views/activity/activity-qr-sign')
  },
  {
    path: '/activity/qr-sign/:activityId/register',
    name: 'activity-qr-sign-register',
    component: () => import('@/views/activity/activity-qr-sign-register')
  },
  {
    path: '/activity/dragon-boat',
    name: 'activity-dragon-boat',
    component: () => import('@/views/activity/activity-dragon-boat')
  },
  {
    path: '/activity/dragon-order',
    name: 'activity-dragon-order',
    component: () => import('@/views/activity/activity-dragon-order')
  },
  {
    path: '/activity/team-pk',
    name: 'activity-team-pk',
    component: () => import('@/views/activity/activity-team-pk')
  },
  {
    path: '/questionnaire/2021',
    name: 'questionnaire',
    component: () => import('@/views/activity/questionnaire2021')
  },
  // {
  //   path: '/questionnaire/2020',
  //   name: 'questionnaire',
  //   component: () => import('@/views/activity/new-questionnaire')
  // },
  // {
  //   path: '/questionnaire/2021',
  //   name: 'Questionnaire2021',
  //   component: () => import('@/views/activity/questionnaire2021')
  // },
  {
    path: '/activity/new-year-gift',
    name: 'new-year-gift',
    component: () => import('@/views/activity/new-year-gift')
  },
  {
    path: '/activity/activity-thanks-letter',
    name: 'activity-thanks-letter',
    component: () => import('@/views/activity/activity-thanks-letter')
  },
  {
    path: '/activity/red-packet-rain',
    name: 'red-packet-rain',
    component: () => import('@/views/activity/red-packet-rain')
  },
  {
    path: '/activity/kt-renewed',
    name: 'kt-renewed',
    component: () => import('@/views/activity/kt-renewed')
  },
  {
    path: '/activity/collect-cards',
    name: 'activity-collect-cards',
    component: () => import('@/views/activity/activity-collect-cards'),
    meta: {
      needLogin: true,
      limitMarket: ['IAM']
    }
  },
  {
    path: '/activity/streaming-verification',
    name: 'activity-streaming-verification',
    component: () => import('@/views/activity/activity-streaming-verification')
  },
  {
    path: '/activity/activity-turntable',
    name: 'activity-turntable',
    component: () => import('@/views/activity/activity-turntable')
  },
  {
    path: '/activity/live-broadcast-login',
    name: 'live-broadcast-login',
    component: () => import('@/views/activity/live-broadcast-login')
  },
  {
    path: '/activity/live-broadcast-register',
    name: 'live-broadcast-register',
    component: () => import('@/views/activity/live-broadcast-register')
  },
  {
    path: '/activity/live-broadcast-coupon',
    name: 'live-broadcast-coupon',
    component: () => import('@/views/activity/live-broadcast-coupon'),
    meta: {
      needWxAuth: true
    }
  },
  // 梦想地图
  {
    path: '/activity/dreaming',
    name: 'activity-dreaming',
    component: () => import('@/views/activity/activity-dreaming')
  },
  // 梦想地图
  {
    path: '/activity/dreaming-support',
    name: 'activity-dreaming-support',
    component: () => import('@/views/activity/activity-dreaming-support'),
    meta: {
      needWxAuth: true
    }
  },
  // 秒杀活动
  {
    path: '/activity/seckill',
    name: 'seckill',
    component: () => import('@/views/activity/activity-seckill')
  },
  {
    path: '/activity/theX-video',
    name: 'TheXVideo',
    component: () => import('@/views/activity/theX-video')
  },
  {
    path: '/activity/activity-video',
    name: 'ActivityVideo',
    component: () => import('@/views/activity/activity-video'),
    meta: {
      needWxAuth: true
    }
  },
  {
    path: '/location-verify',
    name: 'locationVerify',
    component: () => import('@/views/activity/location-verify')
  },
  // 2020双十一
  {
    path: '/activity/double-eleven-2020',
    name: '2020DoubleEleven',
    component: () => import('@/views/activity/double-eleven-2020'),
    meta: {
      needLogin: true
    }
  },
  // 2020感谢信
  {
    path: '/activity/thanks-letter-2020',
    name: '2020ThanksLetter',
    component: () => import('@/views/activity/thanks-letter-2020'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/thanks-letter-cover-2020',
    name: '2020ThanksLetterCover',
    component: () => import('@/views/activity/thanks-letter-cover-2020'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/thanks-letter-poster-2020',
    name: 'thanksLetterPoster',
    component: () => import('@/views/activity/thanks-letter-poster-2020'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/support-poster',
    name: 'supportPoster',
    component: () => import('@/views/activity/support-poster'),
    meta: {
      needWxAuth: true
    }
  },
  // 新年抽奖
  {
    path: '/activity/new-year-draw-2021',
    name: 'new-year-draw-2021',
    component: () => import('@/views/activity/new-year-draw-2021'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/user-scan-transition',
    name: 'user-scan-transition',
    component: () => import('@/views/activity/user-scan-transition'),
    meta: {
      needWxAuth: true
    }
  },
  // WorkShop项目
  {
    path: '/activity/activity-workshop-collect',
    name: 'activity-workshop-collect',
    component: () => import('@/views/activity/activity-workshop-collect'),
    meta: {
      needLogin: true
    }
  },
  // WorkShop项目 基本信息页面
  {
    path: '/activity/activity-workshop-information',
    name: 'activity-workshop-collect-information',
    component: () => import('@/views/activity/activity-workshop-information'),
    meta: {
      needLogin: true
    }
  },
  // WorkShop项目 有奖问答页面
  {
    path: '/activity/activity-workshop-question',
    name: 'activity-workshop-collect-question',
    component: () => import('@/views/activity/activity-workshop-question'),
    meta: {
      needLogin: true
    }
  },
  // WorkShop项目 拍照上传页面
  {
    path: '/activity/activity-workshop-photo',
    name: 'activity-workshop-collect-photo',
    component: () => import('@/views/activity/activity-workshop-photo')
  },
  // WorkShop项目 小游戏页面
  {
    path: '/activity/activity-workshop-game',
    name: 'activity-workshop-collect-game',
    component: () => import('@/views/activity/activity-workshop-game')
  },
  // 九周年活动
  {
    path: '/activity/ninth-year',
    name: 'nine',
    component: () => import('@/views/activity/nine-year'),
    meta: {
      needLogin: true
    }
  }, {
    path: '/activity/ninth-year-part3',
    name: 'part3',
    component: () => import('@/views/activity/nine-year-part3'),
    meta: {
      needLogin: true
    }
  },
  // 视频活动
  {
    path: '/activity/workshop-video/detail',
    name: 'activity/workshop-video/detail',
    component: () => import('@/views/activity/activity-upload-video-detail')
  },
  {
    path: '/activity/workshop-video/enroll',
    name: 'activity/workshop-video/enroll',
    component: () => import('@/views/activity/activity-upload-video')
  },
  // 2021下半年扫码集碎片活动
  {
    path: '/activity/collect-fragment',
    name: 'activity-collect-fragment',
    component: () => import('@/views/activity/activity-scan2021second-half/activity-collect-fragment'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/all-picture',
    name: 'activity-all-picture',
    component: () => import('@/views/activity/activity-scan2021second-half/activity-all-picture'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/fragment-info',
    name: 'activity-fragment-info',
    component: () => import('@/views/activity/activity-scan2021second-half/activity-fragment-info'),
    meta: {
      needLogin: true
    }
  },
  // 视频活动投票
  {
    path: '/activity/video-enroll/list',
    name: 'activity-video-enroll-list',
    component: () => import('@/views/activity/activity-video-enroll-list')
  },
  {
    path: '/activity/video-enroll/info',
    name: 'activity-video-enroll-info',
    component: () => import('@/views/activity/activity-video-enroll-info'),
    meta: {
      needWxAuth: true
    }
  },
  {
    path: '/activity/poster/submit',
    name: 'activity-poster-submit',
    component: () => import('@/views/activity/activity-poster-submit'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/plain/qrCode/scan',
    name: 'plain-qrCode-scan',
    component: () => import('@/views/activity/plain-qrCode-scan'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/gbb/qrCode/scan',
    name: 'gbb-qrCode-scan',
    component: () => import('@/views/activity/gbb-qrCode-scan'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/logistics-inform',
    name: 'logistics-inform',
    component: () => import('@/views/activity/logistics-inform')
  },
  {
    path: '/sp-questionnaire-part2',
    name: 'sp-questionnaire-part2',
    component: () => import('@/views/activity/sp-questionnaire-part2'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/activity-mid-autumn',
    name: 'activity-mid-autumn',
    component: () => import('@/views/activity/activity-mid-autumn'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/activity-workshop-enroll',
    name: 'activity-workshop-enroll',
    component: () => import('@/views/activity/activity-workshop-enroll')
  },
  {
    path: '/activity/activity-workshop-goLogin',
    name: 'activity-workshop-goLogin',
    component: () => import('@/views/activity/activity-workshop-goLogin')
  },
  {
    path: '/activity/activity-workshop-login',
    name: 'activity-workshop-login',
    component: () => import('@/views/activity/activity-workshop-login')
  },
  {
    path: '/activity/2021/activity-booth',
    name: 'activity-2021-activity-booth',
    component: () => import('@/views/activity/2021/activity-booth'),
    meta: {
      needWxAuth: true
    }
  },
  {
    path: '/activity/2021/activity-booth-mall',
    name: 'activity-2021-activity-booth-mall',
    component: () => import('@/views/activity/2021/activity-booth-mall')
  },
  {
    path: '/activity/2021/activity-booth-share',
    name: 'activity-2021-activity-booth-share',
    component: () => import('@/views/activity/2021/activity-booth-share'),
    meta: {
      needWxAuth: true
    }
  },
  {
    path: '/activity/2022/scan-first-half',
    name: '2022-scan-first-half',
    component: () => import('@/views/activity/2022/scan-first-half'),
    meta: {
      // needLogin: true,
      needWxAuth: true
    }
  },
  {
    path: '/activity/2021/activity-ad-meeting',
    name: 'activity-ad-meeting',
    component: () => import('@/views/activity/2021/activity-ad-meeting'),
    meta: {
      needWxAuth: true
    }
  },
  {
    path: '/quality-assurance-ws',
    name: 'quality-assurance-ws',
    component: () => import('@/views/activity/quality-assurance/quality-assurance-ws'),
    meta: {
      needLogin: true,
      needWxAuth: true
    }
  },
  {
    path: '/quality-assurance-ws-info',
    name: 'quality-assurance-ws-info',
    component: () => import('@/views/activity/quality-assurance/quality-assurance-ws-info'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/quality-assurance-ws-result',
    name: 'quality-assurance-ws-result',
    component: () => import('@/views/activity/quality-assurance/quality-assurance-ws-result'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/quality-assurance-ws-feedback',
    name: 'quality-assurance-ws-feedback',
    component: () => import('@/views/activity/quality-assurance/quality-assurance-ws-feedback'),
    meta: {
      needLogin: true,
      needWxAuth: true
    }
  },
  {
    path: '/quality-assurance-agency-detail',
    name: 'quality-assurance-agency-detail',
    component: () => import('@/views/activity/quality-assurance/quality-assurance-agency-detail'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/refuel',
    name: 'activity-refuel',
    component: () => import('@/views/activity/2022/activity-refuel.vue'),
    meta: {
      needLogin: true,
      needWxAuth: true
    }
  },
  {
    path: '/activity/refuel-lottery',
    name: 'activity-refuel-lottery',
    component: () => import('@/views/activity/2022/activity-refuel-lottery.vue'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/refuel-share',
    name: 'activity-refuel-share',
    component: () => import('@/views/activity/2022/activity-refuel-share.vue'),
    meta: {
      needWxAuth: true
    }
  },
  {
    path: '/activity/refuel-share-detail',
    name: 'activity-refuel-share-detail',
    component: () => import('@/views/activity/2022/activity-refuel-share-detail.vue'),
    meta: {
      needWxAuth: true
    }
  },
  {
    path: '/activity/2022/activity-2022-scan',
    name: 'activity-2022-scan',
    component: () => import('@/views/activity/2022/activity-2022-scan.vue'),
    meta: {
      needLogin: true,
      needWxAuth: true
    }
  },
  {
    path: '/activity/2022/activity-2022-scan-rank',
    name: 'activity-2022-scan-rank',
    component: () => import('@/views/activity/2022/activity-2022-scan-rank.vue'),
    meta: {
      needLogin: true,
      needWxAuth: true
    }
  },
  {
    path: '/activity/2022/questionnaire2022',
    name: 'activity-2022-questionnaire2022',
    component: () => import('@/views/activity/2022/questionnaire2022.vue'),
    meta: {
      needLogin: true,
      needWxAuth: true
    }
  },
  {
    path: '/quality-assurance-ws-feedback-detail',
    name: 'quality-assurance-ws-feedback-detail',
    component: () => import('@/views/activity/quality-assurance/quality-assurance-ws-feedback-detail'),
    meta: {
      needLogin: true,
      needWxAuth: true
    }
  },
  // 新增摘星路由
  {
    path: '/activity/2022/activity-star-pick',
    name: 'activity-star-pick',
    component: () => import('@/views/activity/2022/activity-star-pick.vue')
    // meta: {
    //   needLogin: true
    // }
  },
  // 新增雨刮视频路由
  {
    path: '/activity/2022/activity-wiper-video',
    name: 'activity-wiper-video',
    component: () => import('@/views/activity/2022/activity-wiper-video.vue')
    // meta: {
    //   needLogin: true
    // }
  },
  // 新增"易"卡券路由
  {
    path: '/activity/2023/activity-cards',
    name: 'activity-cards',
    component: () => import('@/views/activity/2023/activity-cards.vue')
    // meta: {
    //   needLogin: true
    // }
  },
  {
    path: '/activity/2023/activity-cards-ranking',
    name: 'activity-cards-ranking',
    component: () => import('@/views/activity/2023/activity-cards-ranking.vue')
    // meta: {
    //   needLogin: true
    // }
  },
  {
    path: '/activity/2023/activity-collectCards',
    name: 'activity-collectCards',
    component: () => import('@/views/activity/2023/activity-collectCards.vue'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/2023/activity-collectCards-record',
    name: 'activity-collectCards-record',
    component: () => import('@/views/activity/2023/activity-collectCards-record.vue'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activity/2023/activity-collectCards-ranking',
    name: 'activity-collectCards-ranking',
    component: () => import('@/views/activity/2023/activity-collectCards-ranking.vue'),
    meta: {
      needLogin: true
    }
  }

]

export default activityRoutes
